import { useState } from 'react';

const useDrawer = () => {
    const [state, setState] = useState(false);

    const toggleDrawer = (anchor, open) => (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
      setState(open);
    };

    return {
        state, setState,
        toggleDrawer
    }
  
}

export default useDrawer;